import * as React from "react";
import { cn } from "@repo/utils/cn";
import Image from "next/image";

export interface VideoPlayerButtonProps {
  onClick?: () => void;
  className?: string;
  playButtonImage?: {
    src: string;
    alt: string;
    width: number;
    height: number;
  };
}

export const VideoPlayerButton: React.FC<VideoPlayerButtonProps> = ({
  onClick,
  className,
  playButtonImage,
}) => {
  return (
    <button
      onClick={onClick}
      data-video-button
      className={cn("video-player-button", className)}
      style={{
        position: "absolute",
        inset: "0",
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "rgba(0, 0, 0, 0.3)",
        transition: "all 0.3s ease",
        cursor: "pointer",
      }}
      aria-label="Play video"
    >
      {playButtonImage ? (
        <div
          data-play-icon
          style={{
            transition: "transform 0.3s ease",
            transform: "scale(1)",
          }}
        >
          <Image
            src={playButtonImage.src}
            alt={playButtonImage.alt}
            width={playButtonImage.width}
            height={playButtonImage.height}
          />
        </div>
      ) : (
        <svg
          width="100"
          height="100"
          viewBox="0 0 100 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="50" cy="50" r="50" fill="#3EBD37" />
          <path
            d="M77.4888 46.5165C79.995 47.9635 79.995 51.581 77.4888 53.028L37.6391 76.0351C35.1328 77.4821 32 75.6735 32 72.7795L32 26.765C32 23.871 35.1328 22.0623 37.6391 23.5093L77.4888 46.5165Z"
            fill="white"
          />
        </svg>
      )}
    </button>
  );
};
